export default __webpack_public_path__ + "static/media/flat.61b34369.svg";